
import {defineComponent} from 'vue';
import Table from '@ohrm/oxd/core/components/Table/Table.vue';
import TableHeader from '@ohrm/oxd/core/components/Table/TableHeader.vue';
import TableBody from '@ohrm/oxd/core/components/Table/TableBody.vue';
import TableFooter from '@ohrm/oxd/core/components/Table/TableFooter.vue';
import TableRow from '@ohrm/oxd/core/components/Table/TableRow.vue';
import TableHeaderCell from '@ohrm/oxd/core/components/Table/TableHeaderCell.vue';
import TableDataCell from '@ohrm/oxd/core/components/Table/TableDataCell.vue';

export default defineComponent({
  name: 'oxd-clasic-table',

  data() {
    return {
      checkedItems: this.selected as number[],
      selectedAll: (this.selected.length === this.items.length) as boolean,
    };
  },

  watch: {
    checkedItems(state) {
      this.selectedAll = state.length === this.items.length;
      this.$emit('update:selected', state);
    },
  },

  props: {
    selector: {
      type: Object,
      default() {
        return {width: '30px'};
      },
    },
    headers: {
      type: Array,
      default() {
        return [];
      },
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    withStrip: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  emits: ['click', 'clickCheckbox', 'update:selected', 'update:selectAll'],

  components: {
    'oxd-table': Table,
    'oxd-thead': TableHeader,
    'oxd-tbody': TableBody,
    'oxd-tfoot': TableFooter,
    'oxd-tr': TableRow,
    'oxd-th': TableHeaderCell,
    'oxd-td': TableDataCell,
  },

  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onClick(item: any) {
      return (e: Event) => {
        this.$emit('click', {item, native: e});
      };
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onClickCheckbox(item: any, e: Event) {
      e.stopPropagation();
      this.$emit('clickCheckbox', {item, native: e});
    },
    onChangeSelectAll() {
      this.checkedItems = this.selectedAll
        ? [...Array(this.items.length).keys()]
        : [];
      this.$emit('update:selectAll', this.selectedAll);
    },
  },
});
